import {combineReducers} from 'redux';
import * as ACTION from './constants';
import {setCollectionItem} from '../../common/services/helps';

let complaints = (state = [], action) => {
    let {type, payload} = action;

    switch (type) {
        case ACTION.RECEIVE_COMPLAINT.REQUEST:
            return setCollectionItem(state, payload.id, {loading: true, error: null});

        case ACTION.RECEIVE_COMPLAINT.SUCCESS:
            return setCollectionItem(state, action.request.id, {loading: false});

        case ACTION.RECEIVE_COMPLAINT.FAILED:
            return setCollectionItem(state, action.request.id, {loading: false, error: payload});

        case ACTION.CLEAR_STATE:
            return state.filter(complaint => complaint.id !== payload.id);

        default:
            return state;
    }
};

export default combineReducers({
    complaints,
});
